import React from "react";
import { FaInstagram, FaLinkedin, FaFacebook, FaGlobe } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 - Maxime HUYLBROECK EI — Photographe culinaire - Tous droits réservés - Siret : 799 493 952 00037</p>

      <p>
</p>

      <div className="social-icons">
        <a href="https://www.maximeh.fr" target="_blank" rel="noopener noreferrer" aria-label="Site">
          <FaGlobe />
        </a>
        <a href="https://www.instagram.com/maximehphoto" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <FaInstagram />
        </a>
        <a href="https://www.linkedin.com/in/maximehculinaire/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <FaLinkedin />
        </a>
        <a href="https://www.facebook.com/maximehculinaire" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <FaFacebook />
        </a>
      </div>
    </footer>
  );
}